import React, {FC} from "react";

import statusConfirmation from "../../../images/Progress/progress_bestaetigung.svg";
import WizardStep from "../WizardStep";
import {Typography} from "@material-ui/core";
import {useSelector} from "react-redux";
import {RootState} from "../../../redux/rootReducer";
import {useGlQueryParam} from "../../slideRouter/queryParamHook";

const StepConfirmation: FC = () => {

    const {email, address: {name, lastName}} = useSelector((state: RootState) => state.contact);
    const {emailSuffix} = useGlQueryParam();

    return (
        <WizardStep title={"Bestätigung"} icon={statusConfirmation}>

            <Typography style={{marginBottom: 25, padding: "0 20px"}} align={"center"} component={"p"}>
                Vielen Dank. Sie erhalten in Kürze eine E-Mail an <em
                style={{color: "#67bbbf", textDecoration: "underline", fontStyle: "normal"}}>{email}</em>,<br/>
                in der Sie alle Informationen für den weiteren Verlauf erhalten.
            </Typography>
            <Typography style={{fontSize: 15, padding: "0 20px"}} align={"center"} component={"p"}>
                Falls Sie weitere Fragen haben, senden Sie uns eine E-Mail an&nbsp;
                <a
                    href={`mailto:info@ankaufperpost.${emailSuffix}?subject=Weitere Fragen von ${name} ${lastName}`}
                    target={"_blank"}
                    style={{color: "#67bbbf"}}
                >
                    {`info@ankaufperpost.${emailSuffix}`}
                </a>
                &nbsp;<br/>
                oder rufen Sie uns an unter&nbsp;
                <em style={{color: "#67bbbf", fontStyle: "normal", display: "inline-block"}}>+49 30 914 890 88</em>
            </Typography>

        </WizardStep>
    );
};

export default StepConfirmation;
